export default __webpack_public_path__ + "static/media/ic_check.2c602e83.svg";